/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { BsFileEarmark } from 'react-icons/bs';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { intersection } from 'lodash';
import CustomReviewSectionSettingsForm from './CustomReviewSectionArray.settingsForm';
import getLocalParams from '../localizationCustoms';
import { addFileNames, getFieldValueAndLabel, addLabelValuePair, setPage } from './utils';
import './CustomReviewSection.scss';

const CustomReviewSection = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setValue = this.setValue.bind(this);
  }

  componentDidMount() {
    const review = this.getReviewValue();
    this.setValue(review);
  }

  setValue = (v) => {
    const { onChange } = this.props;
    this.setState({ value: v }, () => {
      const { value } = this.state;
      onChange(value);
    });
  };

  getReviewValue = () => {
    const { data, component: { arrayPath, reviewPaths, filePaths, valAsArray } } = this.props;
    const arrayReview = { instances: [] };

    let arrayData = data;
    arrayPath && arrayPath.split('.').every((key) => {
      if (arrayData[key]) {
        arrayData = arrayData[key];
        if (Object.keys(arrayData).length === 1 && arrayData.data) {
          arrayData = arrayData.data;
        }
        return true;
      }
      return false;
    });

    arrayData && arrayData.length > 0 && arrayData.forEach((arrayInstance) => {
      const review = { fields: [], files: [] };

      reviewPaths && reviewPaths.trim().split(',').forEach((path) => {
        let label;
        let val;

        if (path.split('.').length > 1) {
          let newData = arrayInstance;
          path.split('.').every((key) => {
            if (newData[key]) {
              newData = newData[key];
              if (Object.keys(newData).length === 1 && newData.data) {
                newData = newData.data;
              }
              if (newData?.review) {
                ({ val, label } = getFieldValueAndLabel(newData));
              }
              return true;
            }
            return false;
          });
        } else {
          const field = arrayInstance[path];
          ({ val, label } = getFieldValueAndLabel(field));
        }

        review.fields.concat(addLabelValuePair(review.fields, label, val, valAsArray));
      });

      filePaths && filePaths.trim().split(',').forEach((path) => {
        const fileNames = addFileNames(path, arrayInstance);
        review.files = review.files.concat(fileNames);
      });

      arrayReview.instances.push(review);
    });

    return arrayReview;
  };

  render() {
    const { component: { key, label, reviewEdit, hideCustomLabel, arrayTitle, reviewPage }, data, root } = this.props || undefined;
    const { value } = this.state || undefined;
    const valueToRender = window.sessionStorage.getItem('resumeReview') ? data[key] : (value || data[key]);
    const maskedFields = new Set(['Contact', 'Driver', 'Driver name', 'Issuing province', 'License No.', 'License plate', 'Address', 'Additional details', 'Explanation', 'Owner\'s info', 'Description', 'Contact Info', 'Property']);
    const injuryTypes = ['Stiff and sore', 'Cuts and bruises', 'Broken bones', 'Unconscious after the accident', 'Airlifted from scene', 'Loss of life', 'Raideur et douleurs musculaires', 'Coupures et éraflures', 'Fractures', 'Inanimation après l\'incident', 'Transport par hélicoptère', 'Décès'];

    return (
      <div className="claim-review-section">
        {(!hideCustomLabel || reviewEdit) && (
          <div className="claim-review-section--header">
            {!hideCustomLabel && <label className="section-title-review"><FormattedMessage id={label} defaultMessage={label} /></label>}
            {reviewEdit && reviewEdit !== ''
              && (
                <button
                  type="button"
                  className="edit-button-review"
                  onClick={() => {
                    setPage(root, reviewPage);
                    window.dispatchEvent(new CustomEvent('reviewEdit', {
                      detail: {
                        key: 'setPage',
                        page: reviewPage,
                      },
                    }));
                  }}
                >
                  <FormattedMessage id={reviewEdit} defaultMessage={reviewEdit} />
                </button>
              )}
          </div>
        )}
        <div className="claim-review-section--body">
          {valueToRender && valueToRender.instances && typeof valueToRender.instances === 'object' && valueToRender.instances.length > 0 && valueToRender.instances.map((instance, index) => (
            <div className="claim-review-section--instance">
              {arrayTitle && (
                <div className="claim-review-section--header">
                  <label className="section-title-review"> <FormattedMessage id={arrayTitle.replace(' >index<', '')} defaultMessage={arrayTitle.replace(' >index<', '')} /> {arrayTitle.includes('>index<') ? index + 1 : ''} </label>
                </div>
              )}
              {instance && instance.fields && instance.fields.map((field) => {
                const answerStyle = (maskedFields.has(field.label) || field.label?.endsWith('on policy')) ? 'review-answer fs-exclude' : 'review-answer';
                if (typeof field.val === 'object' && field.val) {
                  const labelStyle = field.val?.length && intersection(injuryTypes, field.val).length ? 'review-question fs-exclude' : 'review-question';
                  return (
                    <div className="claim-review-section--field">
                      <span className={labelStyle}><FormattedMessage id={field.label} defaultMessage={field.label} />:</span>
                      <span className="multiple-options">
                        {field.val.map((v) => (
                          <span className={answerStyle}><FormattedMessage id={v} defaultMessage={v} /></span>
                        ))}
                      </span>
                    </div>
                  );
                } if (field.val) {
                  return (
                    <div className="claim-review-section--field">
                      <span className="review-question"><FormattedMessage id={field.label} defaultMessage={field.label} />:</span>
                      <span className={answerStyle}><FormattedMessage id={field.val} defaultMessage={field.val} /></span>
                    </div>
                  );
                }
                return false;
              })}
              {instance && instance.files && instance.files.length > 0 && (
                <div className="claim-review-section--field file-list">
                  <span className="review-question"><FormattedMessage id="Uploads:" defaultMessage="Uploads:" /></span>
                  {instance.files.map((file) => (
                    <div className="claim-review-section--field">
                      <span className="review-answer review-answer--file fs-exclude">
                        <div className="file-container"><BsFileEarmark style={{ color: '#323232' }} /></div>
                        {file}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
};

export default class ReviewFieldComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Review Section - Array',
      icon: 'terminal',
      group: 'layout',
      documentation: '',
      schema: ReviewFieldComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customreviewsectionarray',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomReviewSectionSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    await element.getElementsByTagName('input').value;

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomReviewSection
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue} // The onChange event to call when the value changes.
          root={this.root}
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
